/**
 * Created by 1 on 2017/8/29.
 * 日志输出工具类
 */
'use strict';
define([],function(){
    /**
     * 使用的日志类型 log4js/console
     * @type {string}
     */
    var type='log4js';
    /**
     *
     * @namespace
     */
    var logger={};

    var _logger=null;

    /**
     *
     * @returns {*} -logger对象
     * @private
     */
    logger._getLogger=function(){
        if(_logger==null){
            logger.setOptions({
                type:'console'
            });
        }
        return  _logger;
    }
    /**
     * 设置参数
     * @method
     * @param options
     * @param options.type {String} 非必填，默认为'console'，可选值为 console/log4js
     * @param options.appender {String} 非必填，只有在type为log4js时有效，默认值为popup，可选值为popup/inpage
     */
    logger.setOptions=function(options){
        if(options){
            if(options.type==='log4js'){
                if(window['log4javascript']){
                    var appenders={
                        'popup':new log4javascript.PopupAppender(),
                        'inpage':new log4javascript.InPageAppender()
                    };
                    _logger=window['log4javascript'].getLogger('main');
                    log.addAppender(appenders[options.appender||'popup']);
                }else{
                    throw(new Error('log4javascript is not defined!'))
                }
            }else if(options.type==='console'){
                _logger=window.console;
            }else{
                _logger=window.console;
                // throw(new Error('logger type console or log4js supported!'));
            }
        }
    }

    /**
     *
     * @method
     * @param obj
     */
    logger.info=function(obj){
        logger._getLogger().info(obj);
    }
    /**
     *
     * @method
     * @param obj {Object} -trace信息
     */
    logger.trace=function(obj){
        logger._getLogger().trace(obj);
    }
    /**
     * 调试信息
     * @method
     * @param obj {Object} -调试信息
     */
    logger.debug=function(obj){
        logger._getLogger().debug(obj);
    }
    /**
     * 警告信息
     * @method
     * @param obj {string} -警告信息
     */
    logger.warn=function(obj){
        logger._getLogger().warn(obj);
    }
    /**
     * 输出错误信息
     * @method
     * @param obj {Object} -输出错误信息
     */
    logger.error=function(obj){
        logger._getLogger().error(obj);
    }
    /**
     * 清空信息
     * @method
     * @param obj {Object} -清空信息
     */
    logger.clear=function(){
        logger._getLogger().clear(obj);
    }

    return logger;
});